export default Object.freeze({
  entitiesSummary: {},
  eventsSummary: {},
  eventOverview: [],
  entityOverview: [],
});
